import * as React from 'react'
import { useStoryblok } from '../../lib/storyblok'
import { DesktopNavigation } from './DesktopNavigation'
import { MobileNavigation } from './MobileNavigation'
import { SbEditableBlok } from '@storyblok/storyblok-editable'
import { AnnouncementBanner, AnnouncementBannerGroup, AnnouncementBannerLink } from '../UI/AnnouncementBanner'
import { AnnouncementBannerText } from '../UI/AnnouncementBanner/styled'
import CustomLink from '../CustomLink'

export interface HeaderProps {
  headerData: SbEditableBlok
  subNavigation?: JSX.Element
}

export const Header = ({ headerData, subNavigation }) => {
  const { content } =
    typeof window !== 'undefined' ? useStoryblok(headerData, window.location) : useStoryblok(headerData)

  const [deprecatedBannerVisible, setDeprecatedBannerVisible] = React.useState(false);

  React.useEffect(() => {
    const isLegacyProduct = legacyProductsPath.some(path => window.location.pathname.includes(path));
    setDeprecatedBannerVisible(isLegacyProduct);
  }, []);

  const legacyProductsPath = [
    '/products/conversion/pdf-optimizer/',
    '/products/conversion/pdf-to-pdf-a-converter/',
    '/products/conversion/image-to-pdf-converter/',
    '/products/conversion/pdf-to-image-converter/',
  ]


  return (
    <>
      {deprecatedBannerVisible &&
        <AnnouncementBanner>
          <AnnouncementBannerText>Did you know that our Pdf Tools SDK offers the same features and more?</AnnouncementBannerText>
          <AnnouncementBannerGroup>
            <AnnouncementBannerLink
              icon="arrow-right"
              as={CustomLink}
              to={'/products/conversion/pdf-tools-sdk/'}
            >
              See Pdf Tools SDK
            </AnnouncementBannerLink>
          </AnnouncementBannerGroup>
        </AnnouncementBanner>}
      <DesktopNavigation data={content} />
      <MobileNavigation data={content} />
      {subNavigation}
    </>
  )
}
